import React, { useEffect, useState } from 'react';
import { adminCommentsAPI } from '../../services/api';
import { Button } from '../ui/button';

const AdminCommentsPage = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const load = async () => {
    try {
      setLoading(true);
      setError(null);
      const data = await adminCommentsAPI.list();
      setItems(Array.isArray(data) ? data : []);
      window.dispatchEvent(new CustomEvent('comments-changed'));
    } catch (e) {
      setError('Erreur de chargement');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    load();
  }, []);

  const approve = async (id) => {
    try { await adminCommentsAPI.approve(id); await load(); } catch { setError("Échec d'approbation"); }
  };

  const remove = async (id) => {
    if (!window.confirm('Supprimer ce commentaire ?')) return;
    try { await adminCommentsAPI.remove(id); await load(); } catch { setError('Échec de suppression'); }
  };

  return (
    <div className="container mx-auto px-4 sm:px-6 lg:px-8 py-10">
      <div className="flex items-center justify-between mb-6">
        <h1 className="text-2xl font-bold">Modération des commentaires</h1>
        <Button onClick={load} className="bg-gray-200 text-gray-800">Recharger</Button>
      </div>
      {error && <div className="text-red-600 text-sm mb-3">{error}</div>}
      {loading ? (
        <div>Chargement...</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full text-sm">
            <thead>
              <tr className="text-left border-b">
                <th className="py-2">Nom</th>
                <th className="py-2">Message</th>
                <th className="py-2">Note</th>
                <th className="py-2">Photos</th>
                <th className="py-2">Approuvé</th>
                <th className="py-2">Actions</th>
              </tr>
            </thead>
            <tbody>
              {items.map((c) => (
                <tr key={c.id} className="border-b">
                  <td className="py-2">{c.name}</td>
                  <td className="py-2 max-w-md truncate" title={c.message}>{c.message}</td>
                  <td className="py-2">{c.rating || '-'}</td>
                  <td className="py-2">
                    <div className="flex gap-1">
                      {(c.photos || []).map((u, i) => (
                        <img key={i} src={u} alt={`p-${i}`} className="w-10 h-10 object-cover rounded" />
                      ))}
                    </div>
                  </td>
                  <td className="py-2">{c.approved ? 'Oui' : 'Non'}</td>
                  <td className="py-2 flex gap-2">
                    {!c.approved && <Button size="sm" className="bg-green-600 text-white" onClick={() => approve(c.id)}>Approuver</Button>}
                    <Button size="sm" className="bg-red-600 text-white" onClick={() => remove(c.id)}>Supprimer</Button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          {items.length === 0 && <div className="text-sm text-gray-500 mt-3">Aucun commentaire</div>}
        </div>
      )}
    </div>
  );
};

export default AdminCommentsPage;